export const zh_cn = {
    "TRIGGER_LISTEN": "监听触发器",
    "ASSIST_EMPTY_MSG": "代理 AI 正在积极监听，准备在触发时自动协助。",
    "MYBOT_TRIGGET_LISTEN": "目前没有 My Bot 任务",
    "MYBOT_EMTPY_MSG": "要启动 My Bot 任务，请转到搜索选项卡并选择所需任务的“使用代理输入执行”选项。",
    "PROACTIVE_MODE": "主动模式",
    "SETTINGS": "设置",
    "HELP_AND_SUPPORT": "帮助与支持",
    "HELP": "帮助",
    "LANGUAGE": "语言",
    "THEME": "主题",
    "AUTOMATIC": "自动",
    "DARK": "深色",
    "LIGHT": "浅色",
    "THEME_DESC": "这将使用您的系统默认模式。",
    "DOCUMENTATION": "文档",
    "DOC_DESC": "阅读我们全面的文档文章。",
    "FAQ_U": "常见问题",
    "FAQ_DESC": "查看 Agent AI 的常见问题。",
    "AUTOSCROLL_ASSIST":"自动滚动辅助",
    "KORE_ACADEMY": "Kore 学院",
    "FILE_NAME":"文件名",
    "ASK_A_QUESTION":"提问",
    "AUTO_SCROLL_TOOLTIP":"控制辅助选项卡、我的机器人和转录选项卡内容的自动滚动",
    "KORE_ACA_DESC": "通过学院课程了解有关 Agent AI 的更多信息。",
    "SEARCH": "搜索",
    "MY_BOT": "我的 Bot",
    "ASSIST": "协助",
    "TRANSCRIPT": "记录",
    "HISTORY": "历史",
    "TAB_TEXT":"未启用任何选项卡！请至少启用一个选项卡",
    "STARTOVER": "重新开始",
    "RESTART_INPUTS": "使用已捕获的输入重新启动",
    "ASKCUSTOMER": "询问客户",
    "TELLCUSTOMER": "告诉客户",
    "WELCOME_MSG": "欢迎消息",
    "TAP_SEARCH":"点击搜索",
    "SEND": "发送",
    "SENT": "已发送",
    "AWAITING": "等待回复 | 点击继续",
    "OVERRIDE": "点击继续",
    "ACCEPT_RESPONSE": "接受回复",
    "AGENT_ENTERED": "代理已进入",
    "EXPECTED_FORMAT": "预期格式",
    "INPUT_VALUES": "输入值",
    "RESTART": "重启",
    "START_OVER": "重新开始",
    "RESTART_CAPTURE": "使用已捕获的输入重新启动",
    "CANCEL": "取消",
    "INTERRUPT_DIALOG": "对话任务中断",
    "RUN": "运行",
    "RUN_AGENT": "使用代理输入执行",
    "STEP": "步骤",
    "DIALOG_TASK": "对话任务",
    "FAQ": "常见问题",
    "SNIPPET": "答案",
    "ARTICLE": "文章",
    "FILE": "文件",
    "SUGGESTED": "建议",
    "ALL_DIALOG": "所有对话任务",
    "DIALOG_TEXT": "对话",
    "INTENT_IDENTIFIED": "已识别意图",
    "NOT_WHAT_LOOKING": "建议不正确？",
    "BOT": "机器人",
    "CUSTOMER": "客户",
    "YOU": "你",
    "TERMINATE_CONV": "终止对话任务",
    "TERMINATE_CONV_DESC": "您确定要终止对话任务吗？代理 AI 将无法再提供建议。",
    "YES_TERMINATE": "是，终止",
    "NO_CANCEL": "否，取消",
    "OVERRIDE_CONTINUE": "以覆盖模式继续",
    "SUMMARY_TEXT": "摘要",
    "SUBMIT": "提交",
    "INTERRUPT_OCCURED": "发生中断",
    "IDENTIFIED_INTENT": "已识别意图",
    "INTERRUPT_DESC": "执行将结束您当前的对话任务。",
    "ACCEPT_RUN": "接受并执行",
    "RUN_LATER": "稍后执行",
    "KNOW_MORE": "了解更多",
    "MORE_TEXT": "更多",
    "LESS_TEXT": "更少",
    "VIEW_MORE": "显示更多",
    "VIEW_LESS": "显示更少",
    "SHOW_MORE_FAQ": "显示更多常见问题",
    "SHOW_LESS_FAQ": "显示更少常见问题",
    "SHOW_MORE_ARTICLE": "显示更多文章",
    "SHOW_LESS_ARTICLE": "显示更少文章",
    "SHOW_MORE_SNIPPET": "显示更多答案",
    "SHOW_LESS_SNIPPET": "显示更少答案",
    "SHOW_MORE_FILES": "显示更多文件",
    "SHOW_LESS_FILES": "显示更少文件",
    "VIEW_ALL_DIALOG": "查看所有对话",
    "VIEW_FEW_DIALOG": "查看一些对话",
    "HELP_FULL": "有帮助吗？",
    "THANKYOU": "谢谢！",
    "EXPAND_MORE": "显示更多 / 更多",
    "CLOSE_TEXT": "关闭",
    "STARTED": "已开始",
    "ENDED": "已结束",
    "VIEW_FULL_ARTICLE": "查看完整文章",
    "VIEW_FULL_FILE": "查看完整文件",
    "COPIED": "已复制",
    "SENTI_ANALY": "情感分析",
    "WRONG_SUGGESTION": "错误建议",
    "INCORRECT_INTENT": "意图错误",
    "ACCIDENTAL_CLICK": "意外点击",
    "TIME_TAKING": "耗时",
    "OTHER": "其他",
    "PLAYBOOK_EMPTY_MSG": "选择一个剧本",
    "PLAYBOOK_EMPTY_DESC": "代理 AI 无法加载剧本，因为所有可用剧本都是动态的。点击“选择剧本”以访问剧本。",
    "STAGE": "阶段",
    "PROCEED_TO_CLOSE": "继续关闭",
    "RECOMENDED_PLAYBOOK": "推荐剧本",
    "PRIMARY_SCRIPTS": "主要脚本",
    "DYNAMIC_SCRIPTS": "动态脚本",
    "RESUME": "继续",
    "ENABLE_CLOSE": "点击“继续关闭”按钮以启用关闭阶段。",
    "LIST_VIEW": "列表视图",
    "TERMINATE": "终止",
    "MINIMIZE": "最小化",
    "MAXIMIZE": "最大化",
    "NO_SEARCH_RESULT": "未找到搜索结果",
    "SENTIMENT_AWAITING": "等待情感分析",
    "POSITIVE": "积极",
    "NEGATIVE": "消极",
    "COPY": "复制",
    "TELL_US_MORE": "告诉我们更多…",
    "THANKS_FEEDBACK": "フィードバックありがとうございます",
    "SOMETHING_WRONG": "何かが間違っています",
    "CLICK_ERROR_DETAILS": "エラーの詳細を見るにはクリックしてください",
    "NO_ACTIVE_PLAYBOOK": "アクティブなプレイブックはありません",
    "REPHRASE_QUESTION": "質問を言い換えるか、別の質問をしていただけますか？",
    "VIEW_FULL_ARTICLE_2": "全文を表示",
    "VIEW_FULL_FILE_2": "全ファイルを表示",
    "INTERNAL_INFO": "内部情報",
    "SOURCES": "ソース",
    "CONVERSATION_SUMMARY": "会話の要約",
    "WAITING": "待機中",
    "WIDGET_DISABLED": "ウィジェットは無効化されています",
    "AI_SETTINGS_DISABLED": "AI設定は無効化されています！AI管理者にお問い合わせください",
    "SERVER_CONNECTION_ERROR": "サーバーへの接続中にエラーが発生しました",
    "VIEW": "表示",
    "ATTACHMENT_INPUT": "添付ファイル入力",
    "TYPE_SUMMARY": "要約を入力してください",
    "BY":"通过",
    "PLAYBOOK": "剧本",
    GENERATE_SUMMARY: "生成摘要",
     PREV_SUMMARIES: "先前生成的摘要",
    DIALOG_WORKFLOWS: "对话工作流程",
    SHOW_ALL_DIALOG: "显示所有对话任务",
    SHOW_ALL_DIALOGS: "显示所有对话",
    CUSTOM_TAB: "自定义选项卡",
    AGENT_INPUT: "代理输入",
    CUSTOM_EMPTY_MSG: "当前没有活动的流程",
    CUSTOM_TAB_DESC: "要启动流程，请从屏幕底部的列表中执行一个。",
    SUBMIT_OVERALL_FEEDBACK: "提交总体反馈",
    FEEDBACK_POPUP_SUBTITLE: "关于小部件及其功能的反馈",
    FEEDBACK_SATISFIED: "满意",
    FEEDBACK_UNSATISFIED: "不满意",
    FEEDBACK_PROVIDE_REASONS: "提供更多信息...",
    FEEDBACK_TITLE: "反馈",
    "AGENTIC_THINKING" : "思考中",
    "AGENTIC_AGENT_TITLE" : "代理",
    "AGENTIC_COPILOT_MODE_TITLE" : "代理副驾驶模式",
    "AGENTIC_SENDING_MESSAGE" : "发送中...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot正在积极倾听您的对话，并准备自动提供协助",
    "AGENTIC_SEARCH_RESULTS" : "代理结果",
    "PAUSE_AUTO_SEND" : "暂停自动发送",
    "PAUSE_AGENTIC" : "暂停代理",
    "RESUME_AGENTIC" : "恢复代理",
    "RESUME_AUTO_SEND" : "恢复自动发送"
}
